import React from 'react';
import Text from '@sizeid/commons/components/Text';
import { Icon } from '@sizeid/commons/components/SvgImage';

import H4 from 'components/typo/Heading/H4';
import P from 'components/typo/P';

import { PremadeContentWhiteBoxProps } from '../types';

import TweakedContentWhiteBox from './styled/TweakedContentWhiteBox';

const renderVideo: React.FC<PremadeContentWhiteBoxProps> = props => {
  if (props.video) {
    return (
      // eslint-disable-next-line
      <video width="100%" autoPlay={false} preload="metadata" controls muted>
        <source src={`${props.video}#t=0.5`} type="video/mp4" />
      </video>
    );
  }

  if (props.youtube) {
    return (
      // prettier-ignore
      <iframe title='video' src={props.youtube} width="100%" height="235" frameBorder="0" allowFullScreen />
    );
  }

  return null;
};

const PremadeContentWhiteBox: React.FC<PremadeContentWhiteBoxProps> = props => (
  <TweakedContentWhiteBox>
    {props.title && <H4>{props.title}</H4>}
    {renderVideo(props)}
    <P dark size={2}>
      <>“{props.text}”</>
    </P>
    <Text bold>
      <a href={props.link} target="_blank" rel="noreferrer">
        {props.moreText}
        <Icon image="arrow" rotation={180} size="10px" />
      </a>
    </Text>

    {props.bottomText && props.bottomLogo && (
      <div className="logo-footer">
        <P>{props.bottomText}</P>
        <span>
          <img src={props.bottomLogo} alt="" />
        </span>
      </div>
    )}
  </TweakedContentWhiteBox>
);

export default PremadeContentWhiteBox;
